import { createCachedSelector, path, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { ICoverageAccount } from '../coverageAccount.interface';
import { coverageAccountListSelector } from './coverageAccountList.selector';

// Accounts belonging to a single report — powers the Target Account dropdown.
export const coverageAccountsByReportSelector = createCachedSelector(
  [
    path(coverageAccountListSelector).list(),
    prop<{ reportId: ICoverageAccount['reportId'] }>().reportId(),
  ],
  (list, reportId) => list.filter((account) => account.reportId === reportId),
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ reportId: ICoverageAccount['reportId'] }>().reportId(),
});
